import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';

import { ComponentBase } from '@definitiv-packages/angular-dba-library';
import { CompletedFormDialogComponent, CompletedFormDialogData } from '@definitiv-packages/angular-forms-library';

import { ObjektModel, ObjektService, ObjektViewService, ProjectLanguage, RoofareaModel, RoofareaService, SafetyPointFormModel,
   SafetyPointFormModelService, SafetyPointFormModelView, SafetyPointFormModelViewService, SafetyPointModelView, SafetyPointViewService, TodoModelView, 
   TodoViewService, RoofAreaView,
   DocumentDataType} from '../../../../../roofsafetymanagement-library/src/public-api';
import { ScanService } from '../../services/scan.service';
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';
@Component({
  selector: 'app-object-service-view',
  templateUrl: './object-service-view.component.html',
  styleUrl: './object-service-view.component.scss',
  standalone: false
})
export class ObjectServiceViewComponent extends ComponentBase<ProjectLanguage> implements OnInit, OnDestroy {
  public object: ObjektModel | null = null;
  public roofAreaList: RoofAreaView[] = [];

  private Todo : TodoModelView| null=null;
  private scanSubscription: Subscription;
  public SafetypointFormList : SafetyPointFormModelView[]=[];
  public SafetypointList : SafetyPointModelView[]=[];
    public documentList: Document[] = [];
  constructor(
    private route: ActivatedRoute,
    private objectService: ObjektService,
    private todoViewService: TodoViewService,
    private roofAreaService: RoofareaService,
    private safetyPointService: SafetyPointViewService,
    private documentService: DocumentService,
    private safetyPointFormModelService: SafetyPointFormModelService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
    private matDialog: MatDialog,
    private scanService: ScanService
  ) {
    super();
    this.scanSubscription = this.scanService.safetyPoint.subscribe(electronicId => this.handleElectronicIdScan(electronicId));
  }

  public async ngOnInit(): Promise<void> {
     
    try {
      var objectId = this.route.snapshot.params['objectId'];
      var todoid = this.route.snapshot.params['todoId'];
      
          this.loading = true;
          var resultList = await Promise.all([
            this.objectService.get(objectId),
            this.roofAreaService.getFilteredList({ ObjektID: objectId }),
            this.safetyPointService.getFilteredList({ ObjektID: objectId }),
            this.safetyPointFormModelViewService.getFilteredList({ ObjektID: objectId }),
            this.todoViewService.getList(),
            this.documentService.getList()
      ]);

      resultList[4].sort((a,b)=>{
          return(a.TodoId>b.TodoId)?-1:1;
      })
      
      var todoid = this.route.snapshot.queryParams['todoId'];
      if(todoid){
          if(resultList[4].find(x=>x.TodoId == todoid)){
              this.Todo = resultList[4].find(x=>x.TodoId == todoid)!;      
          }            
      }else{
        this.Todo = resultList[4].filter(x=>x.ObjektId == objectId)[0];      
      }
 
      this.object = resultList[0];
      this.SafetypointFormList = resultList[3];
      this.SafetypointList = resultList[2];
      this.roofAreaList = resultList[1].map(roofArea => new RoofAreaView(roofArea, resultList[2].filter(safetyPoint => safetyPoint.RoofareaId == roofArea.RoofareaID)));
      this.documentList = resultList[5];
      this.roofAreaList.forEach(roofArea =>{ 
          roofArea.safetyPointList.forEach(item =>{
            
              item.Erledigt = (this.SafetypointFormList.filter(x=>x.SafetyPointId == item.SafetyPointId && x.TodoId == this.Todo?.TodoId).length>0)?true:false            
          })
        })
     
      var electronicId = this.route.snapshot.queryParams['electronicId'];
          
      if (electronicId) this.handleElectronicIdScan(electronicId);
    } finally {
      this.loading = false;
    }
  }

  public ngOnDestroy(): void {
    this.scanSubscription.unsubscribe();
  }

  public async openSafetyPointServiceDialog(safetyPoint: SafetyPointModelView): Promise<void> {
    
    if (!safetyPoint.FormId) return;
    
    this.SafetypointFormList = await  this.safetyPointFormModelViewService.getFilteredList({ ObjektID: safetyPoint.ObjektID})
    var safetyPointFormList  = this.SafetypointFormList.filter(x=> x.TodoId== this.Todo?.TodoId &&  x.SafetyPointId == safetyPoint.SafetyPointId);    
    
    var _data = (safetyPointFormList.length>0)? new  CompletedFormDialogData(safetyPoint.FormId, safetyPointFormList[0].CompletedFormId):new CompletedFormDialogData(safetyPoint.FormId);
    try {
        var res = await firstValueFrom(this.matDialog.open(CompletedFormDialogComponent, { data: _data }).afterClosed());
       
        this.loading = true;
        if (res) {     
            
            var formList = await this.safetyPointFormModelService.getFilteredList({TodoId:this.Todo?.TodoId, SafetyPointId:safetyPoint.SafetyPointId});
            if(formList.length==0){

                safetyPoint.Erledigt = true;
                var safetypointForm = new SafetyPointFormModel();
                safetypointForm.CompletedFormId = res.CompletedFormId;
                safetypointForm.TodoId = this.Todo?.TodoId!;
                safetypointForm.SafetyPointId = safetyPoint.SafetyPointId;
                safetypointForm.Datum = new Date();            
                var res1 = await this.safetyPointFormModelService.post(safetypointForm);
            }
            
            await this.todoViewService.getCountTodos();
            this.SafetypointFormList = await this.safetyPointFormModelViewService.getFilteredList({ ObjektID: safetyPoint.ObjektID});
            this.loading = false;
      }else{
        this.loading = false;
      }
    }catch{
      this.loading = false;
    }
  }

  private async handleElectronicIdScan(electronicId: string) {
            
    var roofArea = this.roofAreaList.find(x => x.safetyPointList.some(y => y.ElectronicId == electronicId));    
    if (!roofArea) return;
    roofArea.panelOpen = true;
    var safetyPoint = roofArea.safetyPointList.find(x => x.ElectronicId == electronicId);    
    if (!safetyPoint) return;

    var todoList = await this.todoViewService.getList();
    todoList.sort((a,b)=>{
          return(a.TodoId>b.TodoId)?-1:1;
      })
    
    this.Todo = todoList.find(x=>x.ObjektId == safetyPoint?.ObjektID)!

    if(this.Todo?.TodoId){
        this.openSafetyPointServiceDialog(safetyPoint);
    }    
  }

  getObjektistErledigt(object: ObjektModel|null=null):boolean{
      
      if(!object || !this.Todo) return false;
      return this.SafetypointFormList.filter(x=>x.ObjektID == object.ObjektID && x.TodoId == this.Todo?.TodoId).length == this.SafetypointList.filter(x=>x.ObjektID==object.ObjektID).length && this.SafetypointList.filter(x=>x.ObjektID==object.ObjektID).length>0;
  }

  getRoofareayistErledigt(object: RoofAreaView|null=null):boolean{
          
      if(!object || !this.Todo) return false;      
      return this.SafetypointFormList.filter(x=>x.RoofareaID == object.roofArea.RoofareaID && x.TodoId == this.Todo?.TodoId).length ==  object.safetyPointList.length && object.safetyPointList.length>0;
  }    

    getDokumentList(safetyPoint: SafetyPointModelView){
      
            return this.documentList.filter(x=>x.DataTypeID == DocumentDataType.SafetyPoint && x.DataID == safetyPoint.SafetyPointId)
    }

}
